import { getGlobalObject } from '../../../tools/globalObject';
import { Observable } from '../../../tools/observable';
import { shallowClone } from '../../../tools/utils/objectUtils';
import { SessionPersistence } from '../sessionConstants';
export const MEMORY_SESSION_STORE_KEY = '_DD_SESSION';
export function selectMemorySessionStoreStrategy() {
    return { type: SessionPersistence.MEMORY };
}
export function initMemorySessionStoreStrategy() {
    const globalObject = getGlobalObject();
    // Share the observable across SDK instances (RUM + Logs)
    if (!globalObject[MEMORY_SESSION_STORE_KEY]) {
        globalObject[MEMORY_SESSION_STORE_KEY] = {};
    }
    const memorySession = globalObject[MEMORY_SESSION_STORE_KEY];
    const sessionObservable = new Observable();
    // Wire the local observable to the shared onChange callback so that
    // multiple SDK instances (RUM + Logs) can observe each other's changes.
    const previousOnChange = memorySession.onChange;
    memorySession.onChange = (state) => {
        previousOnChange?.(state);
        sessionObservable.notify({ sessionState: state });
    };
    return {
        async setSessionState(fn) {
            const currentState = memorySession.state ?? {};
            const newState = shallowClone(fn(currentState));
            memorySession.state = newState;
            await Promise.resolve();
            memorySession.onChange?.(newState);
        },
        sessionObservable,
    };
}
//# sourceMappingURL=sessionInMemory.js.map